import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRole } from 'utils/common';

const useAuth = (minRole = 10) => {
  const role = getRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (role < minRole) {
      navigate('/panel/404', { replace: true });
    }
  }, [role, minRole, navigate]);
};

export default useAuth;
